import { logError } from '../../../components/toaster'

export interface ApiAuthorizationServiceData {
  apiKey: string
  serviceKey: string
  authHeader: string
  teamserverURL: string
}

export interface ApiAuthorizationServiceType {
  readonly getInitialData: () => ApiAuthorizationServiceData
  readonly init: () => angular.IPromise<ApiAuthorizationServiceData>
}

type ApiAuthorizationServiceFactoryType = (
  $q: {
    readonly all: angular.IQService['all']
  },
  GlobalService: {
    readonly getTeamserverURL: LegacyGlobalService['getTeamserverURL']
  },
  UserFactory: {
    readonly getApiKey: LegacyUserFactory['getApiKey']
  },
  userKeysService: {
    readonly getServiceKeys: LegacyUserKeysService['getServiceKeys']
  },
  ProfileService: {
    readonly getUid: LegacyProfileService['getUid']
  }
) => ApiAuthorizationServiceType

export const ApiAuthorizationServiceFactory: ApiAuthorizationServiceFactoryType =
  ($q, GlobalService, UserFactory, userKeysService, ProfileService) => {
    'ngInject'

    const state: ApiAuthorizationServiceData = {
      apiKey: '',
      serviceKey: '',
      authHeader: '',
      teamserverURL: ''
    }

    return {
      getInitialData: () => state,
      init: () => {
        return (
          $q
            .all([UserFactory.getApiKey(), userKeysService.getServiceKeys()])
            // Wait until both requests are resolved
            .then(([apiKeyResponse, serviceKeyResponse]) => {
              state.apiKey = apiKeyResponse.data.api_key
              state.serviceKey = serviceKeyResponse.service_key

              // Build authorization header value
              const userId = ProfileService.getUid()
              const serviceKey = serviceKeyResponse.service_key
              state.authHeader = btoa(`${userId}:${serviceKey}`)
            })
            .then(() => {
              // Return data for controller/view to use
              state.teamserverURL = GlobalService.getTeamserverURL()
              return state
            })
            .catch((error) => {
              const errorMessage = 'Failed to load API key data: '
              console.error(errorMessage, error)
              logError(errorMessage)
              return state
            })
        )
      }
    }
  }
